import { useGreenhouses } from '../hooks/useGreenhouses';
import { CreateGreenhouseDialog } from '../components/greenhouses/CreateGreenhouseDialog';
import { GreenhousesTable } from '../components/greenhouses/GreenhousesTable';
import { LoadingAnimation } from '@/shared/components/LoadingAnimation';

export const GreenhouseManagement = () => {
  const { data: greenhouses, isLoading, error } = useGreenhouses();

  if (isLoading) {
    return <LoadingAnimation fullScreen />;
  }

  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 p-4">
        <p className="text-red-600">Failed to load greenhouses</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Greenhouses</h1>
          <p className="text-gray-500 mt-1">
            Manage your greenhouses and facilities
          </p>
        </div>
        <CreateGreenhouseDialog />
      </div>

      <GreenhousesTable greenhouses={greenhouses || []} />
    </div>
  );
};